"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full border border-t-3 border-yellow-500 my-10 max-w-screen-xl m-auto" }, null, -1);
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("header", { class: "flex justify-center px-5" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full max-w-screen-xl" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { class: "uppercase text-4xl leading-squished font-black mb-10" }, " Bespoke ")
    ])
], -1);
const _hoisted_3 = { class: "bg-beige-200 flex justify-center px-5 pt-10 pb-20 mb-20" };
const _hoisted_4 = { class: "w-full max-w-screen-xl" };
const ListingPreviewGrid_vue_1 = __importDefault(require("./ListingPreviewGrid.vue"));
const ListingPreviewList_vue_1 = __importDefault(require("./ListingPreviewList.vue"));
const Listings_1 = require("../../stores/Listings");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BespokeListingsList',
    props: {
        listings: null
    },
    setup(__props) {
        const props = __props;
        const store = (0, Listings_1.useListingsStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (__props.listings.length > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_2.normalizeClass)(["w-full grid grid-cols-1 mb-11", (0, vue_2.unref)(store).$state.view === 'grid' ? 'md:grid-cols-2 lg:grid-cols-3 gap-10' : 'gap-6'])
                            }, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.listings, (listing) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((0, vue_2.unref)(store).$state.view === 'list' ? ListingPreviewList_vue_1.default : ListingPreviewGrid_vue_1.default), { listing: listing }, null, 8, ["listing"]));
                                }), 256))
                            ], 2))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ])
            ], 64));
        };
    }
});
